import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map, shareReplay, switchMap, take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { WeatherDTO } from '../../shared/dto/weather/weather.dto';
import { WeatherForecast } from '../../shared/models/weather-forecast';

const STATEHOUSE_ZIP = "02133";
const REFRESH_INTERVAL = 60000; //1 minute
const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root'
})
export class WeatherService {

  private cache$: Observable<WeatherForecast>;

  constructor(private http: HttpClient) { }

  get currentWeather$() {
    if (!this.cache$) {
      const timer$ = timer(0, REFRESH_INTERVAL);

      this.cache$ = timer$.pipe(
        switchMap(_ => this.requestCurrentWeather()),
        shareReplay(CACHE_SIZE),
        take(1)
      );
    }

    return this.cache$;
  }

  private requestCurrentWeather() {
    return this.http.get<WeatherDTO>(`${environment.OPEN_WEATHER_API_URL}?appid=${environment.OPEN_WEATHER_API_KEY}&zip=${STATEHOUSE_ZIP}&units=imperial`).pipe(
      map(dto => new WeatherForecast(dto))
    );
  }
}
